import { useTranslations } from "@/lib/static-intl";

const ChatConfirmationModal = ({ onOkText = "ok", onCancel, onOk }) => {
  const userProfileT = useTranslations("user_profile");
  return (
    <div className="w-full flex items-center gap-2 justify-items-end flex-row-reverse">
      <button
        type="button"
        className="px-2 py-1 capitalize rounded-md bg-gray-200 dark:bg-brown text-black dark:text-white text-sm cursor-pointer"
        onClick={onCancel}
      >
        {userProfileT("cancel")}
      </button>
      <button
        type="button"
        className="px-2 py-1 capitalize rounded-md bg-yellow-400 text-black dark:text-white text-sm cursor-pointer"
        onClick={onOk}
      >
        {onOkText}
      </button>
    </div>
  );
};

export default ChatConfirmationModal;
